var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPhotoUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#26366D;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#1D8DCC;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.5,8.5c2.2,0,4,1.8,4,4v24c0,2.2-1.8,4-4,4h-24c-2.2,0-4-1.8-4-4v-24c0-2.2,1.8-4,4-4H36.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.7,37.6c0.6-3.6,3-6.6,6.2-8.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.1,29.5c1.2,0.5,2.2,1.3,3.2,2.2c1.6,1.6,2.7,3.6,3.1,5.9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 24.5,
    cy: 23.5,
    rx: 7,
    ry: 8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhotoUpload);
export default __webpack_public_path__ + "static/media/ic-photo-upload.4f03335445e9973dad63a5a7c8089816.svg";
export { ForwardRef as ReactComponent };